export default "__VITE_ASSET__BHeBTgWL__"